<template>
  <div>
    <config-main-title> Configurações de Cobrança </config-main-title>

    <div class="row mb-3">
      <div class="col col-12 col-md-6">
        <az-input icon="fas fa-search" v-model="search" />
      </div>
      <div class="col col-12 col-md-3 d-flex flex-column">
        <div class="btn-group mb-1" role="group" aria-label="Basic example">
          <button
            type="button"
            class="btn"
            :class="viewMode == 'A' ? 'btn-secondary' : 'btn-outline-secondary'"
            @click="viewMode = 'A'"
          >
            Ativos
          </button>
          <button
            type="button"
            class="btn"
            :class="viewMode == 'T' ? 'btn-secondary' : 'btn-outline-secondary'"
            @click="viewMode = 'T'"
          >
            Todos
          </button>
        </div>
      </div>
      <div class="col col-12 col-md-3 d-flex flex-column">
        <button
          type="button"
          class="btn btn-outline-success"
          @click="incluir_configuracao_cobranca()"
        >
          Incluir
        </button>
      </div>
    </div>

    <div v-if="lista && lista_filtrada.length > 0">
      <div class="list-group mb-3 az-anime-surgir mb-3">
        <li
          class="list-group-item"
          v-for="(configuracao, id) in lista_filtrada"
          :key="id"
        >
          <div class="d-flex justify-content-between">
            <span class="h5 card-link mb-0 mr-3">
              <a href="#" @click.prevent="editar_configuracao_cobranca(configuracao)">
                {{ configuracao.search }}
              </a>
            </span>
            <span>
              <div class="custom-control custom-switch" v-if="viewMode == 'T'">
                <input
                  type="checkbox"
                  class="custom-control-input"
                  :id="'categoria-' + id"
                  v-model="configuracao.fl_ativo"
                  @change="alternar_status(configuracao)"
                />
                <label class="custom-control-label" :for="'categoria-' + id"></label>
              </div>
            </span>
          </div>
        </li>
      </div>
    </div>

    <div v-else>
        <az-empty-state msg="Nenhum Cobranca Configurado..." icon="fa-solid fa-credit-card" />
    </div>

    <div
      class="modal fade"
      id="modalConfiguracaoServicoCobrancas"
      tabindex="-1"
      role="dialog"
      aria-labelledby="modelTitleId"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-xl modal-dialog-scrollable" role="document">
        <div class="modal-content" v-if="item">
          <div class="modal-header">
            <h5 class="modal-title">
              Configurações dos Cobrancas
              <span
                class="badge badge-secondary ml-2"
                v-if="item.id_configuracao_cobranca"
                >#{{ item.id_configuracao_cobranca }}</span
              >
              <span class="badge badge-secondary ml-2" v-else>Nova</span>
            </h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <div class="row">
              <div class="col col-12 col-md-6">
                <az-input
                  label="Título"
                  required
                  placeholder="Título da configuração..."
                  :validate="validate"
                  v-model="item.st_titulo"
                />
              </div>
              <div class="col col-12 col-md-6">
                <AzInput
                  label="Serviço Cobranca"
                  type="select"
                  placeholder="Selecione..."
                  :optionsList="servicos_cobranca"
                  optionsData="name"
                  optionsDisplay="name"
                  :validate="validate"
                  :edicao="!item.id_configuracao_cobranca"
                  v-model="item.js_configs.cobranca"
                  required
                />
              </div>
            </div>
            <div class="row">
              <div class="col col-12 col-md-6">
                <az-input
                  label="Unidade"
                  type="select"
                  placeholder="Todas as unidades..."
                  optionsData="id_unidade_operacao"
                  :optionsList="$util.unidades_com_tags(false, true)"
                  v-model="item.id_unidade_operacao"
                />
              </div>
            </div>

            <az-sub-title title="Campos" class="mt-3" />
            <template
              v-if="item.js_configs.cobranca
                && carregar_campos_servico(item.js_configs.cobranca).length > 0 "
            >
              <div
                v-for="(campo, index) in carregar_campos_servico(
                  item.js_configs.cobranca
                )"
                :key="index"
              >
                <az-input
                    v-if="campo == 'idFormaCobrancaRecDiretoProf'"
                    :label="labelCampo(campo)"
                    type="select"
                    placeholder="Selecionar..."
                    optionsData="id_forma_cobranca"
                    service="forma_cobrancas.index"
                    :optionsParm="{ repasse_devol: true }"
                    optionsMode="aql"
                    v-model="item.js_configs[campo]" 
                />
                
                <az-input
                  v-else
                  :label="labelCampo(campo)"
                  v-model="item.js_configs[campo]"
                  :type="
                    campo == 'producao' || campo == 'informaFormaCobranca'
                      ? 'checkbox-group'
                      : ''
                  "
                  sizing="sm"
                  class="mt-1"
                />
              </div>
            </template>

            <br /><br /><br />
          </div>
          <div class="modal-footer">
            <az-audit-log-button
              v-if="item.id_configuracao_cobranca"
              model="configuracaoCobrancas"
              :id="item.id_configuracao_pacs"
            />
            <button type="button" class="btn btn-secondary" data-dismiss="modal">
              Fechar
            </button>
            <az-submit @click="atualizar()">{{ item.id_configuracao_cobranca ? "Atualizar" : "Incluir" }}</az-submit>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import $ from "jquery";
import ConfigMainTitle from "../../cadastros/shared/ConfigMainTitle.vue";
import AzInput from "../../shared/forms/AzInput.vue";
import AzSubmit from "../../util/AzSubmit.vue";
import AzSubTitle from "../../util/AzSubTitle.vue";
import AzAuditLogButton from "../../util/AzAuditLogButton.vue";

export default {
  components: {
    ConfigMainTitle,
    AzInput,
    AzSubmit,
    AzSubTitle,
    AzAuditLogButton,
  },

  data() {
    return {
      lista: [],
      servicos_cobranca: [],
      search: "",
      viewMode: "A",
      item: null,
      validate: false,
      unidade_operacao_atual: null,
    };
  },

  computed: {
    opcoes_depara: function () {
      let opcoes = [
        {
          id: "App\\azure\\local",
          search: "Local",
          service: "locals.index",
          nosync: true,
        },
      ];

      return opcoes;
    },

    lista_filtrada: function () {
      let pesquisar = this.search.trim();
      let parts = pesquisar.replace(" ", ".*");
      let match = parts;
      let reg = new RegExp(match, "i");

      return this.lista.filter((item) => {
        return (
          (item.fl_ativo || this.viewMode == "T") &&
          (!this.search || reg.test(JSON.stringify(item)))
        );
      });
    },
  },

  methods: {
       carregar() {
      this.$util.load(this, {
        service: "configuracao_cobranca",
        parms: {
          cadastro: true,
        },
        loadTo: (res) => {
          this.lista = res;
        },
      });
    },

    incluir_depara() {
      this.item.deparas.push({
        model_type: "",
        model_id: "",
        st_id_externo: "",
        excluido: false,
      });
    },

    labelCampo(campo) {
      if (campo == "informaFormaCobranca") return "Informar/Enviar Formas de Cobranca";
      if (campo == "idFormaCobrancaRecDiretoProf")
        return "Forma de Cobranca Recebimento Direto Profissional";
      if (campo == "cadastroRecepcaoEc") return "Cadastrar EC das Recepções";

      return campo;
    },

    infoFiltroModel(model) {
      if (!this.opcoes_depara || !model) return {};

      let opcao = this.opcoes_depara.find((item) => item.id == model);

      return opcao;
    },

    abrir_modal(item) {
      this.item = null;
      this.$nextTick(() => {
        this.item = JSON.parse(JSON.stringify(item || {}));
      
        this.$util.load(this, {
            service: "cobranca_configuracao",
            loadTo: (res) => {
            this.servicos_cobranca = res;
            $("#modalConfiguracaoServicoCobrancas").modal("show");
            },
        });
      
      });
    },

    incluir_configuracao_cobranca() {
      let item = null;
      this.$nextTick(() => {
        item = {
          st_titulo: "",
          fl_ativo: true,
          id_unidade_operacao: "",
          js_configs: {
            id_pags_service: "",
          },
        };

        this.abrir_modal(item);
      });
    },

    editar_configuracao_cobranca(configuracao) {
      this.abrir_modal(configuracao);
    },

    alternar_status(configuracao) {
      this.$util.toggle(this, {
        service: "configuracao_cobranca",
        dados: configuracao,
      });
    },

    carregar_campos_servico(nome) {
      const servico = this.servicos_cobranca.find((servico) => servico.name == nome);

      if (servico && servico.js_configs) {
        return servico.js_configs;
      }

      return [];
    },

    atualizar() {
        if (!this.item.js_configs) {
            this.$set(this.item, 'js_configs', {});
        }

        this.$util.atualizar(this, {
            service: "configuracao_cobranca",
            dados: this.item,
            modal: "modalConfiguracaoServicoCobrancas",
            callback: () => {
                this.carregar();
            }
        });
    },
  },

  mounted() {
    this.carregar();

    this.breadcrumb = [
      { name: "Configurações", path: "/cadastros" },
      { name: "Configurações de Cobranca", path: "" },
    ];

    this.$store.commit("setBreadcrumb", this.breadcrumb);
    if (this.$store && this.$store.state.state) {
        this.unidade_operacao_atual = this.$store.state.unidade_operacao_atual;
    }
    
  },
};
</script>
<style></style>